import Axios from 'axios'
import { arrayBufferToBase64 } from '../../utils/binaryUtil'
import config from '@/config/config.js'

// const baseUrl = 'http://192.168.119.122:8081'
const baseUrl = config.apiDomain.ALI + '/ext/core-util/public-servant/api/g2e/'
const staffUrl = baseUrl + 'staff'
const searchStaffUrl = baseUrl + 'searchEuidStaffs?limit=40&keyword='
const getStaffPhotoUrl = baseUrl + 'getStaffPhoto'
// const insertFormUrl = '/api/ApplicationFormData/insertNewform'
const findStaffOfficialSubstInfoByDateUrl = baseUrl + 'substInfo/findStaffOfficialSubstInfoByDate'
const findStaffOfficialSubstInfoByUrl = baseUrl + 'substInfo/findStaffOfficialSubstInfoBy'

// Axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
Axios.defaults.headers.timeout = 8000

export default {

  getStaff (cb) {
    Axios.get(staffUrl).then(
      response => {
        cb(response.data)
      },
      error => {
        console.error(error)
      }
    )
  },

  searchStaffsWithEntityAdministrativeSupport (cb, finallyCb, name) {
    return new Promise((resolve, reject) => {
      Axios.get(baseUrl + 'searchEuidStaffsWithEntityAdministrativeSupport?limit=40&keyword=' + encodeURI(name))
        .then(
          response => {
            cb(response.data)
            resolve()
          }
        )
        .catch(error => {
          console.log(error)
          reject(error)
        })
        .finally(finallyCb)
    })
  },

  searchStaffsWithDefinedGroups (cb, finallyCb, name, searchByGroupId) {
    return new Promise((resolve, reject) => {
      Axios.get(baseUrl + `searchEuidStaffsWithDefinedGroups?limit=40&${searchByGroupId ? 'defaultDefinedGroupId' : 'keyword'}=${encodeURI(name)}`)
        .then(
          response => {
            cb(response.data)
            resolve()
          }
        )
        .catch(error => {
          console.log(error)
          reject(error)
        })
        .finally(finallyCb)
    })
  },

  searchStaffsWithEntityAdministrativeSupportAndDefinedGroups (cb, finallyCb, name, searchByGroupId) {
    return new Promise((resolve, reject) => {
      Axios.get(baseUrl + `searchEuidStaffsWithEntityAdministrativeSupportAndDefinedGroups?limit=40&${searchByGroupId ? 'defaultDefinedGroupId' : 'keyword'}=${encodeURI(name)}`)
        .then(
          response => {
            cb(response.data)
            resolve()
          }
        )
        .catch(error => {
          console.log(error)
          reject(error)
        })
        .finally(finallyCb)
    })
  },

  searchStaff (cb, finallyCb, name) {
    return new Promise((resolve, reject) => {
      Axios.get(searchStaffUrl + encodeURI(name))
        .then(
          response => {
            cb(response.data)
            resolve()
          }
        )
        .catch(error => {
          console.log(error)
          reject(error)
        })
        .finally(finallyCb)
    })
  },

  getStaffPhoto (cb) {
    Axios.get(getStaffPhotoUrl, {
      responseType: 'arraybuffer',
      headers: {
        'Accept': 'image/jpeg'
      }
    }).then(
      response => {
        cb(arrayBufferToBase64(response.data))
      },
      error => {
        console.error(error)
      }
    )
  },

  findStaffOfficialSubstInfoByDate (dateStr, cb) {
    Axios.get(findStaffOfficialSubstInfoByDateUrl + '?refDateStr=' + dateStr)
      .then(
        response => {
          cb(response)
        }
      )
      .catch(error => {
        console.log(error)
        cb(error.response)
      })
  },

  findStaffOfficialSubstInfoBy (dateStr, staffCode, subunitEntityId, cb) {
    Axios.get(findStaffOfficialSubstInfoByUrl + '?refDateStr=' + dateStr + '&staffCode=' + staffCode + '&subunitEntityId=' + subunitEntityId)
      .then(
        response => {
          cb(response)
        }
      )
      .catch(error => {
        console.log(error)
        cb(error.response)
      })
  },

  findStaffLeaveInfo (dateStr, staffCode, subunitEntityId, cb) {
    Axios.get(baseUrl + 'substInfo/findStaffLeaveInfo' + '?refDateStr=' + dateStr + '&staffCode=' + staffCode + '&subunitEntityId=' + subunitEntityId)
      .then(
        response => {
          cb(response)
        }
      )
      .catch(error => {
        console.log(error)
        cb(error.response)
      })
  },

  findStaffSubsInfo (dateStr, staffCode, subunitEntityId, cb) {
    Axios.get(baseUrl + 'substInfo/findStaffSubsInfo' + '?refDateStr=' + dateStr + '&staffCode=' + staffCode + '&subunitEntityId=' + subunitEntityId)
      .then(
        response => {
          cb(response)
        }
      )
      .catch(error => {
        console.log(error)
        cb(error.response)
      })
  },

  getStaffBySubunitIdOrGroupId (entityId, subunitId, isGetAllChildrenEntities, cb) {
    Axios.get(baseUrl + 'getStaffBySubunitIdOrGroupId?entityId=' + entityId + '&subunitId=' + subunitId + '&isGetAllChildrenEntities=' + isGetAllChildrenEntities)
      .then(
        response => {
          cb(response)
        }
      )
      .catch(error => {
        console.log(error)
        cb(error.response)
      })
  }

}
